import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { ObjectSettings } from "./ui";

export const ObjectSettingsRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `${routes.objects.settings()}`,
    element: createElement(ObjectSettings),
    children: [...rest],
  };
};
